'use strict';

var React = require('react');

var SvgExportMinor = function SvgExportMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.707 2.293a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 1 0 1.414 1.414l1.293-1.293v7.586a1 1 0 1 0 2 0v-7.586l1.293 1.293a.999.999 0 1 0 1.414-1.414l-3-3zm-7.707 13.707a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-14z"
  }));
};

exports.SvgExportMinor = SvgExportMinor;
